import { useState } from "react";
import { VismedicasCreate } from "./VismedicasCreate";
import { useLoaderData, useParams } from "react-router-dom";

import * as APIUSER from "../services/user";

export function VismedicasNew(props) {
  const vismedicas = useLoaderData();
  // const navigate = useNavigate();

  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);


  // Set default valor for today date
  const todayDate = new Date().toISOString().replace(/T.*/,'').split('-').join('-');
  const currentDate = new Date();
  const currentTime = (currentDate.getHours()<10?'0':'') + currentDate.getHours() + ":" + (currentDate.getMinutes()<10?'0':'') + currentDate.getMinutes();
  
  //const currentTime = '14:1';
  console.log(currentTime)

  const [vismedResp, setVismedResp] = useState(props.especialistaFullName);
  const [vismedFecha, setVismedFecha] = useState(todayDate);
  const [vismedHora, setVismedHora] = useState(currentTime);
  const [vismedObs, setVismedObs] = useState("");
  let { tratamientoId } = useParams();
  let { pacienteId } = useParams();

  // // Load Especialista and Pacieste Autfill Data
  // useEffect(() => {
  //   const loadAutofillData = async () => {
  //     // promise settles and return its result
  //     const especialista = await APIUSER.getCurrentUser();

  //     let especialistaFullName = especialista
  //       ? especialista?.first_name + " " + especialista?.last_name
  //       : "";

  //     // After fetching data stored it in posts state.
  //     setVismedResp(especialistaFullName);
  //   };
  //   // Call the function
  //   loadAutofillData();
  // }, []);

  const submitVismedicas = async (e) => {
    e.preventDefault();
    setIsCreatingButton(true);
    console.log(vismedResp, vismedFecha, vismedObs, tratamientoId, pacienteId);
    try {
      await VismedicasCreate(
        vismedResp,
        vismedFecha,
        vismedHora,
        vismedObs,
        tratamientoId,
        pacienteId
      ).then(
        (val) => {
          console.log(val)
          window.location.replace(
            `../visitas-medicas/${val.id}`
          );
          // navigate(`../${tratamientoId}/hospitalizacion/visitas-medicas/${val.id}`); Reload is needed to update the Menu item List
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div id='content'>
        <form id='formNewElement' onSubmit={submitVismedicas}>
          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='vismedResp'>Responsable</label>
              <div className='control'>
                <input
                  className='input'
                  id='vismedResp'
                  required
                  type='text'
                  value={vismedResp}
                  onChange={(e) => setVismedResp(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='vismedFecha'>Fecha visita</label>
              <div className='control'>
                <input
                  className='input'
                  id='vismedFecha'
                  required
                  type='date'
                  value={vismedFecha}
                  onChange={(e) => setVismedFecha(e.target.value)}
                />
              </div>
            </div>
            {/* <div className='field'>
              <label htmlFor='vismedHora'>Hora de Visita</label>
              <div className='control'>
                <input
                  className='input'
                  id='vismedHora'
                  required
                  type='time'
                  value={vismedHora}
                  onChange={(e) => setVismedHora(e.target.value)}
                />
              </div>
            </div> */}
          </div>
          <div className='field'>
            <label htmlFor='vismedObs'>Observaciones</label>
            <div className='control'>
              <textarea
                className='textarea'
                name='vismedObs'
                id='vismedObs'
                value={vismedObs}
                onChange={(e) => setVismedObs(e.target.value)}
              ></textarea>
            </div>
          </div>
        </form>
      </div>
      <div id='actions'>
        <button 
        className='button is-link' 
        form='formNewElement' 
        type='submit'
        disabled={isCreatingButton}
        >
          {isCreatingButton ? <div className="spinner"></div> : "Guardar"}
        </button>
      </div>
    </>
  );
}
